module.exports = __webpack_public_path__ + "95f3793307bbbf78f71bb411fbdc6f40.svg";